import { render, staticRenderFns } from "./ListagemDocumentoAtaView.vue?vue&type=template&id=3db04da2&scoped=true"
import script from "./ListagemDocumentoAtaView.vue?vue&type=script&lang=js"
export * from "./ListagemDocumentoAtaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db04da2",
  null
  
)

export default component.exports